// Generated from tolgee-en.json. Placeholders that old logs may not have; missing ones show "-".
// ICU throws on a missing placeholder, so every placeholder of a changed message is listed here.
export const MESSAGE_DEFAULTS: Record<string, string[]> = {
  BATCH_CONSUMED: ['lotNumber', 'orderInternalId'],
  BATCH_CREATED: ['itemName', 'lotNumber'],
  BATCH_DELETED: ['itemName', 'lotNumber'],
  BATCH_EXPIRY_ACKNOWLEDGED: ['itemName', 'lotNumber'],
  BATCH_RECEIVED_FROM_INTERFACE: ['itemName', 'lotNumber'],
  BATCH_UPDATED: ['itemName', 'lotNumber'],
  CATEGORY_CREATED: ['name'],
  CATEGORY_DEACTIVATED: ['name'],
  CATEGORY_DELETED: ['name'],
  CATEGORY_REACTIVATED: ['name'],
  CATEGORY_UPDATED: ['name'],
  COMPOUND_MAPPING_ADDED: ['machineId', 'mappingType'],
  COMPOUND_MAPPING_REMOVED: ['machineId', 'mappingType'],
  COMPOUND_MAPPING_UPDATED: ['machineId', 'mappingType'],
  COMPOUND_ORDER_FAILED: ['error'],
  COMPOUND_ORDER_GENERATED: ['externalId'],
  COMPOUND_ORDER_SENT: ['externalId'],
  COMPOUND_RESULT_FAILED: ['error', 'file'],
  COMPOUND_RESULT_RECEIVED: ['externalId', 'releaseStatus'],
  CUSTOMERS_DEACTIVATED: ['name'],
  CUSTOMERS_DELETED: ['name'],
  FAILED_LOGIN_ATTEMPT: ['ipAddress', 'username'],
  GROUP_CREATED: ['name'],
  GROUP_DELETED: ['name'],
  GROUP_UPDATED: ['name'],
  GROUP_UPDATED_STATUS: ['name'],
  HL7_MESSAGE_FAILED: ['controlId', 'error', 'messageType'],
  HL7_MESSAGE_SEND_FAILED: ['controlId', 'error', 'messageType'],
  HL7_MESSAGE_SENT: ['controlId', 'messageType'],
  HL7_PRODUCTION_REPORT_INCOMPLETE: ['therapyInternalId'],
  IMPERSONATION_ENDED: ['adminName'],
  IMPRESONATION_STARTED: ['adminName'],
  LABEL_PRINTED: ['therapyInternalId'],
  LABEL_REPRINTED: ['therapyInternalId'],
  ORDER_PRODUCTION_STARTED: ['orderInternalId'],
  PASSWORD_CHANGED: ['username'],
  PASSWORD_CHANGED_FAILED: ['username'],
  PASSWORD_RESET_COMPLETED: ['username'],
  PASSWORD_RESET_COMPLETED_FAILED: ['username'],
  PASSWORD_RESET_REQUESTED: ['username'],
  PASSWORD_RESET_REQUESTED_FAILED: ['username'],
  PATIENT_ACCESSED: ['name'],
  PATIENT_CHARACTERISTICS_UPDATED: ['name', 'newHeight', 'newWeight', 'oldHeight', 'oldWeight'],
  PATIENT_DOSES_RECALCULATED: ['cause', 'count'],
  PATIENT_GFR_ADDED: ['gfr', 'newGfrInUse', 'oldGfrInUse'],
  PATIENT_GFR_DELETED: ['gfr', 'newGfrInUse', 'oldGfrInUse'],
  PATIENT_IMPORTED: ['code', 'name'],
  PATIENT_INSTRUCTION_NOTE_ADDED: ['patientName'],
  PATIENT_INSTRUCTION_NOTE_PROTOCOL_ADDED: ['cycle', 'day', 'protocolName'],
  PATIENT_INSTRUCTION_NOTE_PROTOCOL_UPDATED: ['cycle', 'day', 'protocolName'],
  PATIENT_INSTRUCTION_NOTE_UPDATED: ['patientName'],
  PATIENT_MERGED: ['code', 'mergedCode', 'mergedName', 'name'],
  PATIENT_PROTOCOL_CYCLES_UPDATED: ['protocolName'],
  PATIENT_PROTOCOL_REACTIVATED: ['protocolName', 'restoredPrescriptions'],
  PATIENT_PROTOCOL_STOPPED: ['cancelledPrescriptions', 'protocolName'],
  PATIENT_THERAPY_SEQUENCE_ADDED: ['id'],
  PATIENT_THERAPY_SEQUENCE_DELETED: ['id'],
  PATIENT_THERAPY_SEQUENCE_MEDICINE_ADDED: ['therapyInternalId'],
  PATIENT_THERAPY_SEQUENCE_MEDICINE_DELETED: ['therapyInternalId'],
  PATIENT_THERAPY_SEQUENCE_MEDICINE_PROTOCOL_ADDED: ['therapyInternalId'],
  PATIENT_THERAPY_SEQUENCE_MEDICINE_PROTOCOL_UPDATED: ['therapyInternalId'],
  PATIENT_THERAPY_SEQUENCE_MEDICINE_UPDATED: ['therapyInternalId'],
  PATIENT_THERAPY_SEQUENCE_PROTOCOL_ADDED: ['cycle', 'day', 'id', 'protocolName'],
  PATIENT_THERAPY_SEQUENCE_PROTOCOL_DELETED: ['id'],
  PATIENT_THERAPY_SEQUENCE_PROTOCOL_UPDATED: ['therapyInternalId'],
  PATIENT_THERAPY_SEQUENCE_UPDATED: ['id'],
  PATIENT_TREATMENT_STOPPED: ['cancelledPrescriptions'],
  PATIENT_UPDATED_BY_INTERFACE: ['code', 'name'],
  PRESCRIPTION_DOSE_LIMIT_CONFIRMED: ['therapyInternalId'],
  PRESCRIPTION_REMADE: ['id'],
  PRESCRIPTION_STATUS_CHANGE: ['therapyInternalId'],
  PRESCRIPTION_VALIDATION_REMOVED: ['therapyInternalId', 'validationRemoved'],
  PRODUCTION_ABORTED: ['orderInternalId'],
  PRODUCTION_COMPLETED: ['orderInternalId', 'productName'],
  PRODUCTION_RELEASED: ['orderInternalId', 'productName'],
  PRODUCTION_SPOILED: ['orderInternalId'],
  PRODUCTION_STARTED: ['orderInternalId', 'therapyInternalId'],
  PRODUCTION_STEP_COMPLETED: ['orderInternalId'],
  PROTOCOL_ACTIVATED: ['protocolName'],
  PROTOCOL_CREATED: ['protocolName'],
  PROTOCOL_DEACTIVATED: ['protocolName'],
  PROTOCOL_DELETED: ['protocolName'],
  PROTOCOL_THERAPY_SEQUENCE_ADDED: ['protocolName'],
  PROTOCOL_THERAPY_SEQUENCE_DELETED: ['protocolName'],
  PROTOCOL_THERAPY_SEQUENCE_DOSE_CHANGED: ['protocolName'],
  PROTOCOL_THERAPY_SEQUENCE_MEDICINE_ADDED: ['protocolName'],
  PROTOCOL_THERAPY_SEQUENCE_MEDICINE_REMOVED: ['protocolName'],
  PROTOCOL_THERAPY_SEQUENCE_SUBSTANCE_CHANGED: ['protocolName'],
  PROTOCOL_THERAPY_SEQUENCE_UPDATED: ['protocolName'],
  PROTOCOL_UPDATED: ['protocolName'],
  REPORT_EXPORTED: ['format', 'rows', 'tab'],
  REPORT_EXPORT_FAILED: ['error', 'tab'],
  REPORT_EXPORT_QUEUED: ['format', 'tab'],
  REPORT_VIEW_CREATED: ['name'],
  REPORT_VIEW_DELETED: ['name'],
  REPORT_VIEW_REORDERED: ['tab'],
  REPORT_VIEW_UPDATED: ['name'],
  REST_VIAL_CREATED: ['itemName'],
  REST_VIAL_DISCARDED: ['itemName'],
  REST_VIAL_EXPIRED: ['itemName'],
  REST_VIAL_IN_USE: ['itemName', 'orderInternalId'],
  REST_VIAL_MOVED: ['itemName'],
  REST_VIAL_USED: ['itemName'],
  RETURN_CREATED: ['medicationName'],
  RETURN_DISCARDED: ['medicationName'],
  RETURN_EXPIRED: ['medicationName'],
  RETURN_IN_USE: ['medicationName', 'orderInternalId'],
  RETURN_MOVED: ['medicationName'],
  RETURN_USED: ['medicationName'],
  SCALE_WEIGHT_CAPTURED: ['label'],
  STOCK_DISCARDED: ['itemName', 'lotNumber'],
  SUBCATEGORY_CREATED: ['name'],
  SUBCATEGORY_DELETED: ['name'],
  SUBCATEGORY_UPDATED: ['name'],
  USER_CREATED: ['username'],
  USER_DEACTIVATED: ['username'],
  USER_DELETED: ['username'],
  USER_GROUP_ADDED: ['groupName', 'userFullName'],
  USER_GROUP_REMOVED: ['groupName', 'userFullName'],
  USER_LOGGED_IN: ['ipAddress', 'username'],
  USER_REACTIVATED: ['username'],
  USER_TEMPORARY_PASSWORD_SET: ['username'],
  USER_UPDATED: ['username'],
  chair_updated: ['therapyInternalId'],
  // logs without an event code: '<action>.<resource>'
  'create.active-substance': ['name'],
  'create.active-substance-category-relation': ['name'],
  'create.active-substance-details': ['name'],
  'create.active-substance-hazard-class': ['itemName'],
  'create.administration-route': ['name'],
  'create.application-form': ['name'],
  'create.batch': ['itemName', 'lotNumber'],
  'create.cancer-type': ['name'],
  'create.company': ['name'],
  'create.consumable': ['name'],
  'create.container-material': ['name'],
  'create.container-type': ['name'],
  'create.customer': ['name'],
  'create.diagnosis': ['name'],
  'create.discard': ['reason'],
  'create.drug-catalog-item': ['name'],
  'create.drugs-category': ['name'],
  'create.general-physician': ['name'],
  'create.group': ['name'],
  'create.hazard-class': ['name'],
  'create.insurance-company': ['name'],
  'create.medication-profile': ['itemName', 'name'],
  'create.medication-profile-allowed-reconstitution-diluent': ['itemName'],
  'create.medication-profile-stability-rule': ['itemName'],
  'create.medicine-form': ['name'],
  'create.patient-therapy-sequence-observation': ['note', 'therapyInternalId'],
  'create.pharmacy': ['name'],
  'create.prescribed-name': ['name'],
  'create.protocol': ['name'],
  'create.protocol-therapy-sequence': ['name'],
  'create.protocol-therapy-sequence-medicine': ['name'],
  'create.rest-vial': ['name'],
  'create.return': ['medicationName'],
  'create.scale-alibi': ['label'],
  'create.section': ['name'],
  'create.solution-detail-type': ['itemName'],
  'create.solution-details': ['name'],
  'create.solution-type': ['name'],
  'create.stability-rule': ['itemName'],
  'create.stability-rule-container-material': ['itemName'],
  'create.stock-location': ['name'],
  'create.storage-label': ['name'],
  'create.substance-category': ['name'],
  'create.supportive-medication-details': ['name'],
  'create.trade-name': ['name'],
  'create.trade-name-consumable': ['itemName'],
  'create.trade-name-reconstitution-solvent': ['itemName'],
  'create.trade-name-stability-rule': ['itemName'],
  'create.treatment-chair': ['name'],
  'create.user': ['name'],
  'create.user-group': ['name'],
  'create.ward': ['name'],
  'delete.active-substance': ['name'],
  'delete.active-substance-category-relation': ['name'],
  'delete.active-substance-details': ['name'],
  'delete.active-substance-hazard-class': ['itemName'],
  'delete.administration-route': ['name'],
  'delete.application-form': ['name'],
  'delete.batch': ['itemName', 'lotNumber'],
  'delete.cancer-type': ['name'],
  'delete.company': ['name'],
  'delete.consumable': ['name'],
  'delete.container-material': ['name'],
  'delete.container-type': ['name'],
  'delete.customer': ['name'],
  'delete.diagnosis': ['name'],
  'delete.drug-catalog-item': ['name'],
  'delete.drugs-category': ['name'],
  'delete.group': ['name'],
  'delete.hazard-class': ['name'],
  'delete.medication-profile': ['itemName', 'name'],
  'delete.medication-profile-allowed-reconstitution-diluent': ['itemName'],
  'delete.medication-profile-stability-rule': ['itemName'],
  'delete.medicine-form': ['name'],
  'delete.pharmacy': ['name'],
  'delete.prescribed-name': ['name'],
  'delete.protocol': ['name'],
  'delete.protocol-therapy-sequence': ['name'],
  'delete.protocol-therapy-sequence-medicine': ['name'],
  'delete.rest-vial': ['itemName'],
  'delete.return': ['medicationName'],
  'delete.section': ['name'],
  'delete.solution-detail-type': ['itemName'],
  'delete.solution-details': ['name'],
  'delete.solution-type': ['name'],
  'delete.stability-rule': ['itemName'],
  'delete.stability-rule-container-material': ['itemName'],
  'delete.stock-location': ['name'],
  'delete.storage-label': ['name'],
  'delete.substance-category': ['name'],
  'delete.supportive-medication-details': ['name'],
  'delete.trade-name': ['name'],
  'delete.trade-name-consumable': ['itemName'],
  'delete.trade-name-reconstitution-solvent': ['itemName'],
  'delete.trade-name-stability-rule': ['itemName'],
  'delete.treatment-chair': ['name'],
  'delete.user': ['name'],
  'delete.user-group': ['name'],
  'delete.ward': ['name'],
  'update.active-substance': ['name'],
  'update.active-substance-category-relation': ['name'],
  'update.active-substance-details': ['name'],
  'update.administration-route': ['name'],
  'update.application-form': ['name'],
  'update.batch': ['itemName', 'lotNumber'],
  'update.cancer-type': ['name'],
  'update.company': ['name'],
  'update.consumable': ['name'],
  'update.container-material': ['name'],
  'update.container-type': ['name'],
  'update.customer': ['name'],
  'update.diagnosis': ['name'],
  'update.drug-catalog-item': ['name'],
  'update.drugs-category': ['name'],
  'update.general-physician': ['name'],
  'update.group': ['name'],
  'update.hazard-class': ['name'],
  'update.insurance-company': ['name'],
  'update.medication-profile': ['itemName', 'name'],
  'update.medication-profile-allowed-reconstitution-diluent': ['itemName'],
  'update.medication-profile-stability-rule': ['itemName'],
  'update.medicine-form': ['name'],
  'update.pharmacy': ['name'],
  'update.prescribed-name': ['name'],
  'update.protocol': ['name'],
  'update.protocol-therapy-sequence': ['name'],
  'update.protocol-therapy-sequence-medicine': ['name'],
  'update.rest-vial': ['itemName'],
  'update.return': ['medicationName'],
  'update.section': ['name'],
  'update.solution-detail-type': ['itemName'],
  'update.solution-details': ['name'],
  'update.solution-type': ['name'],
  'update.stability-rule': ['itemName'],
  'update.stability-rule-container-material': ['itemName'],
  'update.stock-location': ['name'],
  'update.storage-label': ['name'],
  'update.substance-category': ['name'],
  'update.supportive-medication-details': ['name'],
  'update.trade-name': ['name'],
  'update.trade-name-consumable': ['itemName'],
  'update.trade-name-reconstitution-solvent': ['itemName'],
  'update.trade-name-stability-rule': ['itemName'],
  'update.treatment-chair': ['name'],
  'update.user': ['name'],
  'update.user-group': ['name'],
  'update.ward': ['name'],
}
